import _ from 'lodash';
import { Component, OnInit, EventEmitter, Output, Input, inject, DestroyRef } from '@angular/core';
import { FormArray, FormBuilder, FormControl } from '@angular/forms';
import { filter } from 'rxjs/operators';

import * as ExcelJS from 'exceljs/dist/exceljs';
import { CampaignService } from 'app/campaign/services/campaign.service';
import { COLUMNS } from '../../enums/columns';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-import-slide-xlsx',
  templateUrl: './import-slide-xlsx.component.html',
  styleUrls: ['./import-slide-xlsx.component.scss']
})
export class ImportSlideXlsxComponent implements OnInit {
  destroyRef = inject(DestroyRef)
  @Input()
  public schema: any = null;

  @Input()
  public import: FormControl = null;

  @Input()
  public options: FormArray = null;

  @Output()
  public onChange: EventEmitter<any> = new EventEmitter();

  public extensions: string[] = ['xlsx'];

  public errors: string[] = [];

  constructor(
    private formBuilder: FormBuilder,
    private campaignService: CampaignService
  ) { }

  ngOnInit(): void {
    this.import.valueChanges.pipe(
      filter(value => _.isNull(value)),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(() => {
      this.errors = [];
    });

    this.import.valueChanges.pipe(
      filter(value => !_.isNull(value)),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((file: File) => {
      this.onReadFile(file);
    });
  }

  onReadFile(file: File) {
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      // read workbook and grab the first sheet
      const bstr: string = e.target.result;
      const workbook = new ExcelJS.Workbook();

      workbook.xlsx.load(bstr).then(() => {
        const firstSheet = workbook.getWorksheet(1);
        let data = [];
        
        firstSheet.eachRow((rawRow) => {
          let row = []
          let value = null; 

          rawRow.eachCell({ includeEmpty: true }, function(cell) {
            value = cell.value || '';
            
            if(cell.type === ExcelJS.ValueType.Number) {
              const numFmt = cell.numFmt || "0.00";
              if(numFmt[numFmt.length - 1] === "%") {
                value = value * 100;
              }
            }
            row.push(value);
          });

          let values = _.map(row, value => {
            const str = new String(value);
            return str.toString();
          });
          data.push(values);
        });

        data = _.map(data, row => {
          return _.map(row, column => {
            return _.trim(column);
          });
        });
        data = _.filter(data, row => {
          for(let column of row) {
            if(column !== '') {
              return true;
            }
          }
          return false;
        });

        this.options = this.formBuilder.array([], []);
        this.errors = [];
        const result = this.campaignService.transformTo(data, this.schema);
        if(result.length < 1) {
          this.errors = ['Could not find Items'];
          return;
        }

        const list = [];
        _.forEach(result, (obj, row) => {
          const option = this.formBuilder.group({});
          this.campaignService.generateForm(option, this.schema);
          this.campaignService.initializeForm(option, obj, this.schema);

          _.forEach(option.controls, (control, column) => {
            if(control.invalid) {
              _.forEach(control.errors, (value, error)  => {
                if(value) {
                  let errorMessage = `Row ${row+2}, Column "${COLUMNS[column]}".`;
                  switch(error) {
                    case 'required':
                      if(column === 'buyItNowEnabled') {
                        errorMessage += ` Value of column "${COLUMNS[column]}" cannot be 'No' if value of column '${COLUMNS['buyItNowOnlyItem']}' is 'Yes'.`;
                      } else {
                        errorMessage += ` Value of column "${COLUMNS[column]}" cannot be empty.`;
                      }
                      break;
                    case 'min':
                      errorMessage += ` Value of column "${COLUMNS[column]}" cannot be less than ${value.min}.`;
                      break;
                    case 'max':
                      errorMessage += ` Value of column "${COLUMNS[column]}" cannot be greater than ${value.max}.`;
                      break;
                    case 'maxlength':
                      errorMessage += ` Value of column "${COLUMNS[column]}" cannot be longer than ${value.requiredLength}.`;
                      break;
                    default:
                      errorMessage += ' Unknown error.';
                  }
                  this.errors.push(errorMessage);
                }
              })
            }
          });
          this.options.push(option);

          list.push({
            ...this.campaignService.generateRequestObject(option, this.schema),
            id: row
          });
        });

        if(this.errors.length < 1) {
          this.onChange.next(this.options);
        }
      });
    };
    reader.readAsBinaryString(file);
  }

  onSelect(file: File) {
    this.import.setValue(file);
  }

}
